import * as actions from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const unnotificationsModule = {
  state: {
    notifications: [], // buffer
    persistentNotifications: [],
  },
  getters,
  actions,
  mutations
};
